import script from "./TypeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeFilter.vue?vue&type=script&setup=true&lang=js"

import "./TypeFilter.vue?vue&type=style&index=0&id=ddcd8ed4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddcd8ed4"]])

export default __exports__